import { roomAcceptanceStatusIdsMap } from '../../../../constants/room/lifeCycle';
import { intervalModeIds } from '../../shared/configs/selectionData/intervalModes';
import { registrationStage, registrationSteps } from './constants';

const alertMessages = {
  fromWithExpertToWithoutExpert:
    'Предыдущая запись была с экспертом. Выбранный интервал - без эксперта. Вы действительно хотите записать на приемку без эксперта?',
  fromWithoutExpertToWithExpert:
    'Предыдущая запись была без эксперта. Выбранный интервал - с экспертом. Вы действительно хотите записать на приемку с экспертом?',
};

export const getSetupIntervalProps = ({ selectedInterval, initialValues }) => {
  const withExpertByDefault =
    selectedInterval.withExpertId === intervalModeIds.withExpert;

  if (!initialValues) {
    return {
      initialValues: {
        intervalId: selectedInterval.id,
        withExpert: withExpertByDefault,
        byProxy: false,
      },
    };
  }

  const { withExpertId: nextWithExpertId } = selectedInterval;
  const { withExpert: withExpertInit, byProxy: byProxyInit } = initialValues;

  let withExpert = withExpertByDefault;
  let alert;

  const toUniversal = nextWithExpertId === intervalModeIds.universal;
  const fromWithExpertToWithoutExpert =
    withExpertInit && nextWithExpertId === intervalModeIds.withoutExpert;
  const fromWithoutExpertToWithExpert =
    !withExpertInit && nextWithExpertId === intervalModeIds.withExpert;

  if (toUniversal) {
    withExpert = withExpertInit;
  } else if (fromWithExpertToWithoutExpert) {
    alert = alertMessages.fromWithExpertToWithoutExpert;
  } else if (fromWithoutExpertToWithExpert) {
    alert = alertMessages.fromWithoutExpertToWithExpert;
  }

  return {
    initialValues: {
      intervalId: selectedInterval.id,
      withExpert,
      byProxy: typeof byProxyInit === 'boolean' ? byProxyInit : false,
    },
    ...(alert && { alert }),
  };
};

export const groupRoomsByRelations = (rooms) => {
  if (!rooms) return undefined;

  const [mainRoom, ...restRooms] = rooms;

  const result = roomAdapter(mainRoom);

  if (restRooms.length) {
    result.relatedFlats = restRooms.map(roomAdapter);
  }

  return result;
};

const canRegisterRoom = (room) => {
  const stage = getStageId(room);
  const step = getStepId(room);
  return stage === registrationStage && registrationSteps.has(step);
};

const canRegisterWhenHasResult = (room) => {
  const acceptanceStatus = getAcceptanceStatusId(room);

  if (
    acceptanceStatus &&
    acceptanceStatus !== roomAcceptanceStatusIdsMap.notAccepted
  ) {
    return false;
  }

  return canRegisterRoom(room);
};

export const canRegister = (room) => {
  const { relatedFlats, ...restRoom } = room;

  if (!relatedFlats) {
    return canRegisterRoom(restRoom);
  }

  const rooms = [restRoom, ...relatedFlats];

  const hasAcceptanceStatus = rooms.some(
    (r) => getAcceptanceStatusId(r) != null
  );

  if (hasAcceptanceStatus) {
    return canRegisterWhenHasResult(restRoom);
  }

  return rooms.every(canRegisterRoom);
};

function getStageId(room) {
  return room.stageAddressLifeCycle?.id;
}
function getStepId(room) {
  return room.stepAddressLifeCycle?.id;
}
function getAcceptanceStatusId(room) {
  return room.recordInfo?.acceptanceStatusAddressLifeCycle?.id;
}
function roomAdapter(room) {
  const { addressId, id, ...rest } = room;
  return { ...rest, id: id ?? addressId };
}
